/* eslint-disable camelcase */
import React from 'react'
import { Col, Row, Form, Typography } from 'antd'
import PropTypes from 'prop-types'

import InputMask from 'react-input-mask'
import { LogoUploader, ImageUploader } from '~components'
import { RichTextInput, Input } from '~stories'
import styles from './HeroBasicInfo.module.css'
const { Item: AntDFormItem } = Form
const { Title } = Typography

const HeroBasicInfo = ({
  hero,
  handleButtonLabelChange,
  handlePhoneNumberChange,
  handleContentChange,
  handleSubTitleChange,
  handleImageUrlUpdate,
  handleChatLabelChange,
  handleEmailChange,
  handleTitleChange,
  handleImageChange,
  handleImageUrlChange,
  pageType
}) => {
  const {
    button_name: buttonName,
    chat_button: chatButton,
    description,
    email,
    phone_number: phoneNumber,
    sub_title: subTitle,
    title,
    image
  } = hero
  return (
    <div className={styles['hero-basic-info-container']}>
      <Row align={'left'} className={styles['title-wrapper']} gutter={[10, 10]}>
        <Col><Title level={3}>Title*</Title></Col>
      </Row>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <Input maxLength={70} onChange={handleTitleChange} value={title} />
        </Col>
      </Row>
      {/* {!title && <Typography.Paragraph className={styles['paragraph-text']}>Please fill out this field</Typography.Paragraph>} */}
      <Row align={'left'} className={styles['title-wrapper']} gutter={[10, 10]}>
        <Col><Title level={3}>Description</Title></Col>
      </Row>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <RichTextInput onChange={handleContentChange} value={description}/>
        </Col>
      </Row>
      {pageType === 'premium-hospitality' &&
        <div>
          <Row align={'left'} className={styles['title-wrapper']} gutter={[10, 10]}>
            <Col><Title level={3}>Sub Title</Title></Col>
          </Row>
          <Row gutter={[10, 10]}>
            <Col span={24}>
              <Input maxLength={155} onChange={handleSubTitleChange} value={subTitle}/>
            </Col>
          </Row>
          <Row align={'left'} className={styles['title-wrapper']} gutter={[10, 10]}>
            <Col><Title level={3}>Email</Title></Col>
          </Row>
          <Row gutter={[10, 10]}>
            <Col span={24}><Input onChange={handleEmailChange} type='email' value={email}/></Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}><Input label={<Title level={3}>Button Label</Title>} onChange={handleButtonLabelChange} value={buttonName}/></Col>
            <Col span={8}><AntDFormItem>
              <div style={{
                padding: '5px 10px 5px 0px',
                fontSize: 14,
                fontWeight: 'normal'
              }}><Title level={3}>Phone Number</Title></div>
              <InputMask mask="+9 (999) 999-9999"
                onChange={handlePhoneNumberChange}
                style={{
                  width: '100%',
                  padding: '4px 11px',
                  color: 'rgba(0, 0, 0, .85)',
                  fontSize: '14px',
                  lineHeight: '1.5715',
                  backgroundColor: '#fff',
                  border: '1px solid #d9d9d9',
                  borderRadius: '2px'
                }}
                value={phoneNumber} />
            </AntDFormItem></Col>
            <Col span={8}><Input label={<Title level={3}>Chat Label</Title>} onChange={handleChatLabelChange} value={chatButton}/></Col>
          </Row>
          <Row gutter={16}>
            <Col span={18}>
              <Title level={3}>Background Image</Title>
              <div>
                <LogoUploader handleUpload={(thumbnailImageUrl, secureImageURL) => {
                  const imageUrl = secureImageURL || thumbnailImageUrl
                  handleImageUrlUpdate(imageUrl)
                }} logoUrl={image?.src} />
              </div>
            </Col>
          </Row>
        </div>}
      {pageType === 'tours' &&
          <div>
            <Row align={'left'} className={styles['title-wrapper']} gutter={[10, 10]}>
              <Col><Title level={3}>Banner Image*</Title></Col>
              <Col><Title level={4}> (Upload PNG or JPG; preferred dimensions 0px x 0px; max file size 1MB)</Title></Col>
            </Row>
            <Row>
              <Col span={24}>
                <ImageUploader alt={image?.alt} handleIconChange ={(imgObj) => handleImageChange(imgObj)} handleUpload={(url) => handleImageUrlChange(url)} logoUrl={image?.src} pageType={pageType} />
              </Col>
            </Row>
            {/* {((image && !image.url) || !image) && <Typography.Paragraph className={styles['paragraph-text']}>Please upload an image</Typography.Paragraph>} */}
            <br />
          </div>
      }
    </div>
  )
}

HeroBasicInfo.propTypes = {
  handleButtonLabelChange: PropTypes.func,
  handleChatLabelChange: PropTypes.func,
  handleContentChange: PropTypes.func.isRequired,
  handleEmailChange: PropTypes.func,
  handleImageChange: PropTypes.func,
  handleImageUrlChange: PropTypes.func,
  handleImageUrlUpdate: PropTypes.func,
  handleLogoUpload: PropTypes.func,
  handlePhoneNumberChange: PropTypes.func,
  handleShowIconChange: PropTypes.func,
  handleSubTitleChange: PropTypes.func.isRequired,
  handleTitleChange: PropTypes.func.isRequired,
  handleTypeChange: PropTypes.func,
  hero: PropTypes.object.isRequired,
  pageType: PropTypes.string
}

HeroBasicInfo.defaultProps = {
  hero: {}
}

export default HeroBasicInfo
